// Single source of truth for the avatar-bubble layout used in the live
// session and every preview surface. Resize here only.
export const BUBBLE_ASPECT_RATIO = 3 / 4;
export const BUBBLE_MIN_HEIGHT_MOBILE = 240;
export const BUBBLE_MIN_HEIGHT_DESKTOP = 320;
export const BUBBLE_RESIZE_MIN_HEIGHT_MOBILE = 120;
export const BUBBLE_RESIZE_MIN_HEIGHT_DESKTOP = 160;
export const BUBBLE_MAX_HEIGHT_RATIO = 0.65;
export const BUBBLE_SIZE_CLASS = "h-1/3 aspect-[3/4]";
export const BUBBLE_ASPECT_CLASS = "aspect-[3/4]";
